import { getRequest, postRequest, postRequestFormData } from './helper';

export const getLatestBlogsAction = async (data) => {
  const res = await getRequest('blog/getAllBlogs', data);
  return res.data;
};

export const getLatestPressAction = async (data) => {
  const res = await getRequest('getAllPress', data);
  return res.data;
};

export const getLatestVideosAction = async (data) => {
  const res = await getRequest('getAllVideos', data);
  return res.data;
};

export const submitContactDetailsAction = async (data) => {
  const res = await postRequest('user/saveUserData', data);
  return res.data;
};

export const submitInquiryAction = async (data) => {
  const res = await postRequest('saveInquiry', data);
  return res.data;
};


// Home banner section strat
export const getHomeBannerData = async () => {
  const res = await getRequest('home/getHeroBannerData');
  return res.data;
};
// our strategy section start
export const getOurStrategyData = async () => {
  const res = await getRequest('strategy/getStrategyData');
  return res.data;
};
// unitronix explained section start
export const getUnitronixexplainedAction = async () => {
  const res = await getRequest("unitronixexplained");
  return res.data;
}

export const getCryptocurrencyData = async () => {
  const res = await getRequest("cryptocurrencyportfolio/getCryptocurrencydata");
  return res.data;
}

//Empowering Features

export const getEmpoweringFeaturesData = async () => {
  const res = await getRequest("empoweringFeatures");
  return res.data;
}

//How it work

export const getHowItWorkData = async () => {
  const res = await getRequest("howitworks");
  return res.data;
}

// get All chai list

export const getAllChainList = async () => {
  const res = await getRequest("chain-list/getAllChains");
  return res.data;
}


// export const insetFormData= async (values) => {
//   const res = await postRequest("launchprocess/insertFormData" + values);
//   return res.data;
// }

export const insetLaunchProcessRequestAction = async (values) => {
  const res = await postRequestFormData("launchprocess/insetLaunchProcessRequest", values);
  return res.data;
}

export const checkTokenExistence = async (values) => {
  const res = await postRequest("verifyToken", values);
  return res.data;
}

export const getLaunchProcessRequestsAction = async () => {
  const res = await getRequest("launchprocess/getAllProjectsList");
  return res.data;
}

export const getMyProjectAction = async (data) => {
  const res = await postRequest("launchprocess/getMyProject", data);
  return res.data;
}

export const getTokenDetailsAction = async (data) => {
  const res = await getRequest(`launchprocess/getTokenDetails/${data.tokenAddress}`);
  return res.data;
}

export const updateProjectListingStatusAction = async (data) => {
  const res = await postRequest("launchprocess/updateProjectListingStatus", data);
  return res.data;
}

export const userInvestmentAction = async (data) => {
  const res = await postRequest("investment/userInvestment", data);
  return res.data;
}

export const projectSubscribeAction = async (data) => {
  const res = await postRequest("subscribe/projectSubscribe", data);
  return res.data;
}

export const getChainInfoAction = async (chainId) => {
  const res = await getRequest(`chain-list/getChainInfo/${chainId}`);
  return res.data;
}

export const getProjectDetailsAction = async (id) => {
  const res = await getRequest(`launchprocess/getProjectDetails/${id}`);
  return res.data;
}